import React from 'react';
import { DEEP_GREEN, MUTED } from '../operational-excellence/colorTokens';
import ZoomSafeTabs from './ZoomSafeTabs';

/**
 * Tab bar in the HighQ Audit Console style (muted labels, deep-green selected label + underline, hairline divider).
 * Drop-in for <Tabs>/<ZoomSafeTabs>; the <Tab> children need no styling of their own.
 */
const ConsoleTabs = React.forwardRef(({ sx, ...props }, ref) => (
  <ZoomSafeTabs
    ref={ref}
    indicatorColor={DEEP_GREEN}
    {...props}
    sx={[
      {
        minHeight: 0,
        borderBottom: '1px solid rgba(26,46,34,0.12)',
        '& .MuiTab-root': {
          minHeight: 0,
          textTransform: 'none',
          fontFamily: 'inherit',
          fontWeight: 600,
          fontSize: '0.9375rem',
          letterSpacing: '0.01em',
          px: { xs: 1.5, sm: 2.5 },
          py: 1.25,
          color: MUTED,
          '&:hover': { color: DEEP_GREEN },
          '&.Mui-selected': { color: DEEP_GREEN }
        }
      },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
  />
));

ConsoleTabs.displayName = 'ConsoleTabs';

export default ConsoleTabs;
